// Decline ceremony modal. The backend
// auto-creates a DealFailure on decline, so the modal copy warns the
// user that the action is loud.

import { useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Button, Textarea, FormField } from "@/design-system/components/ui";

interface DeclineModalProps {
  open: boolean;
  onClose: () => void;
  itemCode: string;
  onConfirm: (failureReason: string) => void | Promise<void>;
  pending?: boolean;
}

export function DeclineModal({
  open,
  onClose,
  itemCode,
  onConfirm,
  pending = false,
}: DeclineModalProps) {
  const [reason, setReason] = useState("");
  const isValid = reason.trim().length > 0 && reason.length <= 2000;

  return (
    <Modal
      open={open}
      onClose={onClose}
      dismissOnBackdropClick={false}
      title={`Decline ${itemCode}`}
      description="This creates a Failure Tracking record for executive review and is recorded in the audit log."
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={pending}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => void onConfirm(reason)}
            disabled={!isValid || pending}
          >
            {pending ? "Declining…" : "Decline item"}
          </Button>
        </>
      }
    >
      <FormField label="Failure reason" required>
        <Textarea
          rows={5}
          value={reason}
          onChange={(e) => setReason(e.target.value.slice(0, 2000))}
          placeholder="What failed and why? Cite the evidence reviewed."
        />
      </FormField>
      <p className="text-caption text-gray-mid mt-space-2">
        {reason.length}/2000 characters
      </p>
    </Modal>
  );
}
